<template>
  <div id="AttsLesson">
    <div id="scrollBody">
      <ul class="week-list">
        <li
          class="week-item"
          :class="
            date === itemWeek.s && dateCur === itemWeek.s ? 'cur' : date === itemWeek.s ? 'today' : ''
          "
          v-for="(itemWeek, index) in weekDay"
          :key="index"
          @click="datesChange(itemWeek.s)"
          v-cloak
        >
          <span v-cloak class="week">{{ itemWeek.d }}</span>
          <div v-show="itemWeek.s" v-cloak class="date">{{ xy.moment(itemWeek.s).format('DD') }}</div>
        </li>
      </ul>
      <ul v-if="!noData" class="scrollList" slot="list">
        <li
          class="list-item clearfix"
          v-cloak
          v-for="(itemWeek, index) in dateWeek"
          :key="index"
          @click="modalEditAttend(itemWeek)"
        >
          <div class="list-left nowrap fl">
            <span v-cloak>{{ xy.getAMorPMCHN(itemWeek.AMorPM) }}</span>
            <div v-cloak>
              <span v-cloak v-if="itemWeek.AMorPM === 'AM' || itemWeek.AMorPM === 'PM'">第</span
              >{{ xy.convertRangeNumber(itemWeek.AMorPMOrder)
              }}<span v-if="itemWeek.AMorPM === 'AM' || itemWeek.AMorPM === 'PM'">节</span>
            </div>
          </div>
          <div class="list-center fl">
            <span v-cloak class="attend-cont-tit nowrap"
              >{{ itemWeek.SubjectName }}&nbsp;&nbsp;{{ itemWeek.CollectionName }}</span
            >
            <span
              v-cloak
              class="attend-cont-time nowrap"
              v-if="itemWeek.StartTime !== null && itemWeek.StartTime !== ''"
              >{{ itemWeek.StartTime.substring(0, 5) }}-{{ itemWeek.EndTime.substring(0, 5) }}</span
            >
            <span v-cloak class="attend-cont-time" v-else>未设置</span>
            <span v-cloak class="attend-cont-adress nowrap" v-if="itemWeek.HouseName"
              >{{ itemWeek.SchoolDistrictName}}-{{ itemWeek.BuildingName}}-{{
                itemWeek.HouseName
              }}</span
            >
          </div>
          <div class="list-right fr">随堂考勤</div>
        </li>
      </ul>
      <div v-else class="xy-phone-no-data">
        <img src="@/assets/basic/moblie-no-data.png" />
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      // 切换周
      weekdata: '1',

      // 获取课表节次
      dateWeek: '',

      // 获取周时间
      weekDate: '',
      weekDateStrat: '',
      weekDateEnd: '',

      noData: false,

      //获取周一到周日
      weekDay: [
        { d: '一', s: '' },
        { d: '二', s: '' },
        { d: '三', s: '' },
        { d: '四', s: '' },
        { d: '五', s: '' },
        { d: '六', s: '' },
        { d: '日', s: '' }
      ],
      dateCur: this.xy.moment().format('YYYY-MM-DD'), //今天
      date: this.xy.moment().format('YYYY-MM-DD')
    }
  },
  computed: {},
  mounted() {
    // 获取课表内数据
    this.GetClassTableGenerate()
    // 获取周时间
    this.GetCurWeek()
  },
  methods: {
    // 根据时间获取教师排课信息
    async GetClassTableGenerate() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath + '/api/AttsLessonForMobile/GetClassTableGenerateBaseByDate',
        {
          date: this.date,
          type: -2 //迟到：2，旷课：3，早退：4，请假：5，无考勤：0，全部：-2，其他：-1
        }
      )
      if (res.success) {
        if (res.data.length > 0) {
          this.dateWeek = res.data
          this.noData = false
        } else {
          this.noData = true
        }
      } else {
        Toast.fail(res.msg)
      }
    },
    // 获取当前周信息
    async GetCurWeek() {
      let res = await this.xyapi.get(this.$store.state.apiPath + '/api/AttsLessonForMobile/GetCurWeek', {
        week: this.weekdata
      })
      if (res.success) {
        this.weekDate = res.data
        this.weekDateStrat = this.weekDate.start
        this.weekDateEnd = this.weekDate.end
        for (var i = 0; i < 7; i++) {
          this.weekDay[i].s = this.xy
            .moment(res.data.start.replace(/-/g, '/'))
            .add(i, 'day')
            .format('YYYY-MM-DD')
        }
      } else {
        Toast.fail(res.data.msg)
      }
    },
    //选择日期
    datesChange(val) {
      this.date = val
      this.GetClassTableGenerate()
    },
    // 去考勤
    async modalEditAttend(item) {
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          `/api/AttsLessonForMobile/IsAttStatus?baseID=${item.ClassTableGenerateBaseID}`
      )
      if (res.success) {
        if (res.data) {
          this.$router.push({
            name: 'TakeAttendance',
            params: {
              classNode: item
            }
          })
        } else {
          Toast.fail('考勤时间未开始，教师不可做考勤。')
        }
      } else {
        Toast.fail(res.msg)
      }
    }
  }
}
</script>
<style lang="less">
#AttsLesson {
  font-size: 24px;
}
.week-list {
  display: flex;
  background: #fff;
  margin-bottom: 18px;
}
.week-list .week-item {
  flex: 1;
  text-align: center;
  cursor: pointer;
}
.week-item .week {
  font-size: 22px;
  margin-top: 20px;
  display: block;
}
.week-item .date {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #fff;
  color: #545865;
  border-radius: 50%;
  margin: 8px auto 18px;
}
.week-item.today .date {
  background: #515a6e;
  color: #fff;
}
.week-item.cur .date {
  background: #ff9900;
  color: #fff;
}
#scrollBody .scrollList {
  padding: 0 19pxm;
}
#scrollBody .scrollList .list-item {
  padding: 15px 23px;
  margin-bottom: 16px;
  border-radius: 6px;
  box-shadow: 0 2px 20px 0 rgba(197, 197, 197, 0.5);
}
.list-item .list-left {
  width: 130px;
  height: 140px;
  padding-top: 35px;
  text-align: center;
  font-size: 28px;
  color: #fff;
  font-weight: 700;
  background: url(~@/assets/attendance/hexagon-waves-blue.png) no-repeat center;
  background-size: contain;
  margin-right: 40px;
}
.list-center .attend-cont-tit {
  display: block;
  font-size: 30px;
  margin: 12px 0 18px;
  color: #333;
  font-weight: 700;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 10em;
}
.list-center .attend-cont-time {
  display: block;
  margin-bottom: 4px;
  color: #666;
}
.list-center .attend-cont-adress {
  color: #999;
  display: block;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 10em;
}
.list-item .list-right {
  width: 140px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #3182fd;
  border: 1px solid #3182fd;
  border-radius: 4px;
  margin-top: 50px;
}
.xy-phone-no-data {
  width: 100%;
  height: 50%;
  overflow: hidden;
  margin: 40% auto 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  img {
    border: none;
    vertical-align: middle;
  }
  p {
    font-size: 16px;
    text-align: center;
  }
}
</style>
